import { getMethodWithParamWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const SEARCH_PROVIDER_LIST = 'SEARCH_PROVIDER_LIST';
export const SEARCH_PROVIDER_LIST_SUCCESS = 'SEARCH_PROVIDER_LIST_SUCCESS';
export const SEARCH_PROVIDER_LIST_FAILURE = 'SEARCH_PROVIDER_LIST_FAILURE';

// Action Creators
export const fetchGetSearchProvider = () => ({
  type: SEARCH_PROVIDER_LIST,
});

export const fetchGetSearchProviderSuccess = (data) => ({
  type: SEARCH_PROVIDER_LIST_SUCCESS,
  payload: data,
});

export const fetchGetSearchProviderFailure = (error) => ({
  type: SEARCH_PROVIDER_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getSearchProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetSearchProvider(data, external));
    try {
      const response = await getMethodWithParamWithToken(
        url.getSearchProviderList,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetSearchProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetSearchProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetSearchProviderFailure(error.message));
    }
  };
};
